module.exports = __webpack_public_path__ + "img/payment-shoppay.7c73703.svg";